export const makeEnterHandler = (handler) => (event) => {
  if (event.key === 'Enter') {
    handler();
  }
};
